// Generates a secure password
function generatePassword( length: number = 12 ): string {
	if ( length <= 0 ) return '';

	const lowercase = 'abcdefghijklmnopqrstuvwxyz';
	const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
	const numeric = '0123456789';
	const punctuation = '!@#$%^&*_+~,.-='; // optionally extend with '()[]{}|;:<>?'

	const allChars = lowercase + uppercase + numeric + punctuation;

	let password: string;
	let isSecurePassword = false

	do {
		password = getRandomStringFromSet( allChars, length );
		/*
		 * regex with positive lookaheads, checking whether each char from the four
		 * individual charsets is present at least once in the password
		 */
		isSecurePassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*_+~,.\-=]).+$/.test( password );
	} while ( !isSecurePassword );

	return password;
}

// Generates a secure random integer within a specified range
function generateRandomInteger( from: number, to: number ): number {
	if ( !Number.isInteger( from ) || !Number.isInteger( to ) ) { // also tests for correct type and problematic number values
		throw new Error( 'Both min and max must be valid integers' );
	}

	const min = Math.min( from, to );
	const max = Math.max( from, to );
	const rangeSize = max - min + 1;

	// Create a Uint32Array to hold a single 32-bit unsigned integer
	const array = new Uint32Array( 1 );

	// Fill the array with (a) cryptographically secure random value(s)
	window.crypto.getRandomValues( array );

	// Scale that random integer down to the specified range and return it
	return min + ( array[ 0 ] % rangeSize );
}

// Generates a pseudo UUID using cryptographically secure random numbers
function generateUuid(): string {
	function s4(): string {
		return generateRandomInteger( 0, 0xFFFF ).toString( 16 ).padStart( 4, '0' );
	}

	return `${ s4() }${ s4() }-${ s4() }-${ s4() }-${ s4() }-${ s4() }${ s4() }${ s4() }`;
}

// Helper function to construct a randomized string from a given character set
function getRandomStringFromSet( charSet: string, length: number ): string {
	if ( !charSet ) {
		throw new Error( 'Character set must be non-empty' );
	}

	let result = '';
	for ( let i = 0; i < length; i++ ) {
		result += charSet.charAt( generateRandomInteger( 0, charSet.length - 1 ) );
	}
	return result;
}


export const publicFunctions = {
	generatePassword,
	generateRandomInteger,
	generateUuid,
};

/**
 * FOR UNIT TESTS ONLY!
 * Do not import anywhere else than in generators.spec.ts!
 */
export const UT = {
	getRandomStringFromSet
};
